import { useState, useEffect } from 'react';

export function PulsingIndicator({ text }: { text: string }) {
  const [dots, setDots] = useState(1);
  useEffect(() => {
    const id = setInterval(() => setDots((d) => (d % 3) + 1), 500);
    return () => clearInterval(id);
  }, []);
  return (
    <span className="chatAssistant__thinkingDots">
      {text}
      {'.'.repeat(dots)}
    </span>
  );
}
